import { listRecentConsultations } from '../../api/clinical'
import { useFetch } from '../../hooks/useFetch'
import { cn } from '@/lib/utils'
import { thClass, tdClass, tbodyHoverClass, skeletonClass } from '@/lib/tableStyles'
import { DashboardWidgetCard } from './DashboardWidgetCard'
import { ConsultationRow } from './ConsultationRow'

export function RecentConsultationsWidget() {
  const { data: recentConsultations, loading, error } = useFetch(() => listRecentConsultations(10), [])
  const completed = (recentConsultations ?? []).filter(c => c.status === 'completed')

  return (
    <DashboardWidgetCard title="Recent Consultations">
      {error ? (
        <div className="px-5 py-6 text-danger-text text-[0.875rem]">Could not load consultations.</div>
      ) : (
        <table className="w-full border-collapse text-[0.875rem]">
          <thead>
            <tr>
              <th className={thClass}>Reason</th>
              <th className={thClass}>Date</th>
              <th className={thClass}>Practice</th>
              <th className={thClass}>Vet</th>
              <th className={thClass}>Status</th>
              <th className={cn(thClass, 'text-right')}></th>
            </tr>
          </thead>
          <tbody className={tbodyHoverClass}>
            {loading ? (
              Array.from({ length: 4 }).map((_, i) => (
                <tr key={i}>
                  {Array.from({ length: 6 }).map((_, j) => (
                    <td key={j} className={tdClass}>
                      <div className={cn(skeletonClass, 'h-[14px] rounded w-[70%]')} />
                    </td>
                  ))}
                </tr>
              ))
            ) : completed.length === 0 ? (
              <tr>
                <td colSpan={6} className={cn(tdClass, 'text-center py-8 text-text-3')}>
                  No completed consultations yet.
                </td>
              </tr>
            ) : (
              completed.map(c => <ConsultationRow key={c.id} c={c} />)
            )}
          </tbody>
        </table>
      )}
    </DashboardWidgetCard>
  )
}
